import { render, staticRenderFns } from "./HandleReport.vue?vue&type=template&id=3aaf886a&"
import script from "./HandleReport.vue?vue&type=script&lang=js&"
export * from "./HandleReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports